<h2 mat-dialog-title
  class="font-weight-bold">{{dialogData.title}}</h2>
<mat-dialog-content class="justify-content-center">
  <mat-divider></mat-divider>
  <div class="mt-2">
    <span>
      {{dialogData.startTime | date: 'longDate'}} - {{dialogData.endTime | date:'longDate'}}
    </span>
  </div>
  <div class="mt-1">
    {{dialogData.location}}
  </div>

  <div class="mt-3"
    [innerHTML]="dialogData.description| bitfSafeHtml">
  </div>


</mat-dialog-content>
<mat-dialog-actions class="row justify-content-end">
  <button mat-stroked-button
    tabindex="-1"
    (click)="onCancel()">
    {{ 'COMMON.LABEL.CLOSE' | translate }}
  </button>
</mat-dialog-actions>